import React from "react";
import "./NumbersSection.css";
import { useTranslation } from "react-i18next";
import map from "../../../../../assets/images/numbers.png";

function NumbersSection() {
  const { t } = useTranslation("home");
  return (
    <section className="numbers-section">
      <div className="container">
        <div className="numbers-content">
          <h2>{t("numbersSection.heading")}</h2>
          <div className="numbers-layout">
            <div className="numebers-box">
              <h4>{t("numbersSection.firstT")}</h4>
              <h6>{t("numbersSection.projectNos")}</h6>
              <h6 className="service-count">150000+</h6>
            </div>
            <div className="numebers-box">
              <h4>{t("numbersSection.secoundT")}</h4>
              <h6>{t("numbersSection.projectNos")}</h6>
              <h6 className="service-count">5000</h6>
            </div>
          </div>
        </div>
        <img src={map} alt="" />
      </div>
    </section>
  );
}

export default NumbersSection;
